// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Form from 'antd/lib/form';
import 'antd/lib/form/style/css';
// COMPONENTS
import TextInput from 'components/inputs/TextInput';
import PasswordInput from 'components/inputs/PasswordInput';
import Button from 'components/common/Button';
import FormItem from 'components/common/FormItem';
import ErrorList from 'components/common/ErrorList';
import styled from 'styled-components';

// LIB
import formConfig from 'lib/form-config/index';

const ButtonContainer = styled.div`
  text-align: center;
  margin-top: 10px;
`;
// CONSTANTS & DESCTRUCTURING
// ====================================

// EXPORTED COMPONENT
// ====================================
class LoginForm extends React.PureComponent {
  onValidateError = err => {
    this.setState({ loading: false });
    return console.log(err);
  };

  onSubmit = e => {
    e.preventDefault();
    this.setState({ loading: true });
    this.props.form.validateFields((err, values) => {
      if (err) {
        return this.onValidateError(err);
      }
      this.props.onSucessFullyValidated(values);
    });
  };

  fieldIsClean = fieldName => {
    const { getFieldError, getFieldValue } = this.props.form;
    return !(!getFieldError(fieldName) && getFieldValue(fieldName));
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const USERNAME_INPUT_OPTIONS = {
      rules: formConfig.defaultBasicRules,
      // validateTrigger: we don't want to validate on change, we want to validate only onBlur,
      // then if there is a value AND error in the current field,
      // we want to validate onChange so it clears
      validateTrigger: this.fieldIsClean('username') ? 'onBlur' : 'onChange',
    };

    const PASSWORD_INPUT_OPTIONS = {
      rules: formConfig.defaultPasswordRules,
      validateTrigger: this.fieldIsClean('password') ? 'onBlur' : 'onChange',
    };

    return (
      <Form onSubmit={this.onSubmit} id="login-form">
        <FormItem>{getFieldDecorator('username', USERNAME_INPUT_OPTIONS)(<TextInput placeholder="Email" />)}</FormItem>
        <FormItem>{getFieldDecorator('password', PASSWORD_INPUT_OPTIONS)(<PasswordInput />)}</FormItem>
        <ButtonContainer>
          <Button disabled={this.props.loading} loading={this.props.loading} onClick={this.onSubmit} fullWidth>
            {!this.props.loading ? 'Login' : 'Logging In...'}
          </Button>
        </ButtonContainer>
        <ErrorList errors={this.props.errors} />
      </Form>
    );
  }
}

// EXPORT
// ====================================
export default Form.create()(LoginForm);



// WEBPACK FOOTER //
// ./src/components/forms/LoginForm/index.js